import { Progress, Select, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import useSWR from "swr";
import { GET } from "../../utils/requestActionConstants";
import { API_ROUTE } from "../../utils/commonConstants";
import { fetcher } from "../../helpers/processRequest";
import { formatCurrency } from "../../utils/formatters";
import { LineChart } from "../../components/chart/LineChart";
import { BarChart } from "../../components/chart/BarChart";
import { useState } from "react";
import TrendingProducts from "../../components/TrendingProducts";

const Dashboard = () => {
    const navigate = useNavigate();
    const [selectedSummaryDays, setSelectedSummaryDays] = useState('1');
    const metaReponse = useSWR({ method: GET, url: API_ROUTE + '/settings/meta/v2?range=' + selectedSummaryDays }, fetcher);
    const summary = metaReponse.data?.data;

    const onChangeRange = (val) => {
        setSelectedSummaryDays(val);
        metaReponse.mutate();
    }

    return (
        <div>
            <div className="flex justify-between">
                <div className="text-2xl pb-3">Dashboard</div>
                <div className="w-fit">
                    <Select style={{minWidth: 100}} value={selectedSummaryDays} onChange={onChangeRange} options={[{ value: '1', label: 'Today' }, {value: '7', label: '7 Days'}, {value: '30', label: '1 Month'}, {value: '90', label: '3 Months'}, {value: '*', label: 'All'}]} />
                </div>
            </div>
            <div className="px-6 border py-4 bg-white pop-left">
                {metaReponse.isLoading ? (
                    <Skeleton active={true} />
                ) : (
                    <main className="p-6 flex-1 overflow-y-auto">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {/* Card 1 */}
                            <div className="bg-white shadow-md rounded-lg p-6">
                                <h3 className="text-lg font-semibold text-gray-800">Sales</h3>
                                <p className="font-bold text-blue-500 mt-4 flex justify-between"><span>Total:</span> {formatCurrency(summary.payment.total)}</p>
                                <p className="font-bold text-blue-500 flex justify-between"><span>Paid:</span> {formatCurrency(summary.payment.paidTotal)}</p>
                                <p className="font-bold text-blue-500 flex justify-between"><span>Unpaid:</span> {formatCurrency(summary.payment.unPaidTotal)}</p>
                            </div>

                            {/* Card 2 */}
                            <div className="bg-white shadow-md rounded-lg p-6">
                                <h3 className="text-lg font-semibold text-gray-800">Products</h3>
                                <p className="text-2xl font-bold text-green-500 mt-4">{summary.products.count}</p>
                            </div>

                            {/* Card 3 */}
                            <div className="bg-white shadow-md rounded-lg p-6">
                                <h3 className="text-lg font-semibold text-gray-800">Orders</h3>
                                <p className="text-2xl font-bold text-yellow-500 mt-4">{summary.orders.count}</p>
                            </div>
                        </div>

                        <TrendingProducts products={summary.products.trending} />

                        <div className="grid gap-4 lg:grid-cols-2 2xl:grid-cols-3">
                            <div className="pt-5"><BarChart label="Sales Analytics" data={summary.charts.salesBarChart.byMonth}/></div>
                            <div className="pt-5"><BarChart label="Sales Analytics" data={summary.charts.salesBarChart.byDay}/></div>
                        </div>

                        {/* <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6"> */}
                            {/* Large Card */}
                            {/* <div className="bg-white shadow-md rounded-lg p-6"> */}
                                {/* <h3 className="text-lg font-semibold text-gray-800">Recent Activities</h3> */}
                                {/* <ul className="mt-4 space-y-3"> */}
                                    {/* <li className="text-gray-600">✅ Completed task "Design new dashboard UI"</li> */}
                                    {/* <li className="text-gray-600">📤 Sent invoice to client "Acme Corp"</li> */}
                                    {/* <li className="text-gray-600">💬 Responded to support ticket "#12345"</li> */}
                                    {/* <li className="text-gray-600">🚀 Launched project "Marketing Campaign"</li> */}
                                {/* </ul> */}
                            {/* </div> */}

                            {/* Large Card */}
                            {/* <div className="bg-white shadow-md rounded-lg p-6"> */}
                                {/* <h3 className="text-lg font-semibold text-gray-800">Upcoming Deadlines</h3> */}
                                {/* <ul className="mt-4 space-y-3"> */}
                                    {/* <li className="text-gray-600">🗓️ Submit report by <span className="font-bold">Dec 15</span></li> */}
                                    {/* <li className="text-gray-600">📅 Client meeting on <span className="font-bold">Dec 18</span></li> */}
                                    {/* <li className="text-gray-600">🔔 Follow-up email by <span className="font-bold">Dec 20</span></li> */}
                                {/* </ul> */}
                            {/* </div> */}
                        {/* </div> */}
                    </main>
                )}
            </div>
        </div>
    );
}

export default Dashboard;